<template>
  <div class="bot-line-wrapper">
    <el-row>
        <el-col align="center" class="count-edit" :span="24">
            <div v-on:click="toggleCount" class="scheduled-range">{{getMax()}}</div>
            
        </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
    name: 'DaySection',
    components: {
        
    },
    props: {
        playbooks: {
            type: Array,
            default: () => {}
        },
        project: {
            type: Object,
            default: () => {}
        },        
        type: {
            type: String,
            default: ''
        },
        bot_id: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
        
        }
    },
    methods: {
        toggleAdvanced() {
            var state = this.$store.state.project.view;
            state.advanced = true;
            this.$store.dispatch('project/setProjectView', state);
            this.$store.dispatch('project/getPlaybookSettings', {
                project_id: this.project.id, 
                playbook_id: this.playbooks[0].id,
            });
            /*this.$store.dispatch('project/getPlaybookSettings', {
                project_id: this.$route.params.id, 
                playbook_id: element.id,
            });*/
        },
        toggleCount() {
            var state = this.$store.state.project.view;
            state.count = true;
            state.model = this.playbooks[0];   
            state.model.playbook_id = this.playbooks[0].id;             
            state.isNew = false;//flag for update
            
            this.$store.dispatch('project/setProjectView', state);
        },
        getPlaybook() {
            //return (this.hasSettings()) ? 
        },
        hasSettings() {
            if (this.playbooks.length == 0) {
                return false;
            }

            //if playbook has advanced settings id different from the project's, it means it has something specific set up for itself
            return (this.$store.state.project.advanced.data.id == this.playbooks[0].advanced_settings_id) ? false : true;
        },
        isScheduled() {
            return (this.playbooks[0].goal == 0 || this.playbooks[0].goal == null) ? false : true;
        },
        getMin() { 
            var min = this.playbooks[0].goal;//initial value quite random yet real

            for (var i = 0; i < this.playbooks.length; i++) {
                if (this.playbooks[i].goal < min) {
                    min = this.playbooks[i].goal;
                }
            }

            return min;
        },
        getMax() {
            var bot = this.playbooks[0];
            return (bot.distributions[this.type] == null) ? 0 : bot.distributions[this.type];
        }
    }
}
</script>

<style lang="scss" scoped>
    .scheduled-range {
        color: #3d95ae !important;
        cursor: pointer;
        text-decoration: underline dotted;
    }
    .playbook-settings {
        max-height: 16px;
        margin-top:5px;
        cursor:pointer;
    }
    .count-edit{
        cursor: pointer;
    }
</style>
